import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  fetchSubscriptionExtensionRequestsData,
  fetchManualExtensionDataData,
  fetchMemberDetailsByMobileData,
} from "../../redux/plans-reducers/plansSlice";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import SubscriptionMainTabs from "./SubscriptionExtensionMainTab";
import CmnFilters from "../lead-management/common/CmnFilters";
import SubscriptionExtensionTable from "./SubscriptionExtensionTable";
import ManualExtensionTable from "./ManualExtensionTable";
import "../../styles/subscription-extension/subscription-extension.css";
import { Plus } from "../../images/icons/icons";
import { Col, Row } from "react-bootstrap";
import Modal from "react-modal";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import ManualExtensionModal from "./ManualExtensionModal";

const SubscriptionExtenstionStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const {
    subscriptionExtensionRequestsLoading,
    manualExtensionDataLoading,
    memberDetailsByMobile,
    memberDetailsByMobileLoading,
  } = useSelector((state) => state?.plans);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const [activeTab, setActiveTab] = useState("agent-request");

  // pagination state for each tab
  const [agentRequestPage, setAgentRequestPage] = useState(0);
  const [agentRequestPageLimit, setAgentRequestPageLimit] = useState(5);

  const [manualExtensionPage, setManualExtensionPage] = useState(0);
  const [manualExtensionPageLimit, setManualExtensionPageLimit] = useState(5);

  // Initial filter states
  const iniAgentRequestAllFilter = {
    selectedGym:
      !isAdmin && !isMarketing && !isClusterManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedApprovalStatus: null,
    leadAddDateFrom: null,
    leadAddDateTo: null,
  };

  const iniManualExtensionAllFilter = {
    selectedGym:
      !isAdmin && !isMarketing && !isClusterManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    leadAddDateFrom: null,
    leadAddDateTo: null,
  };

  // All filters state
  const [agentRequestAllFilters, setAgentRequestAllFilters] = useState(
    iniAgentRequestAllFilter
  );
  const [manualExtensionAllFilters, setManualExtensionAllFilters] = useState(
    iniManualExtensionAllFilter
  );

  // API filters state
  const iniAgentRequestFilters = {
    page: agentRequestPage + 1,
    limit: agentRequestPageLimit || 5,
    gym_id: iniAgentRequestAllFilter.selectedGym?.value || "",
    date_from: iniAgentRequestAllFilter.leadAddDateFrom || "",
    date_to: iniAgentRequestAllFilter.leadAddDateTo || "",
    approval_status:
      iniAgentRequestAllFilter.selectedApprovalStatus?.value || "all",
  };

  const iniManualExtensionFilters = {
    page: manualExtensionPage + 1,
    limit: manualExtensionPageLimit || 5,
    gym_id: iniManualExtensionAllFilter.selectedGym?.value || "",
    date_from: iniManualExtensionAllFilter.leadAddDateFrom || "",
    date_to: iniManualExtensionAllFilter.leadAddDateTo || "",
  };

  const [agentRequestFilters, setAgentRequestFilters] = useState(
    iniAgentRequestFilters
  );
  const [manualExtensionFilters, setManualExtensionFilters] = useState(
    iniManualExtensionFilters
  );

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [memberMobile, setMemberMobile] = useState("");
  const [memberDetails, setMemberDetails] = useState(null);
  const [extendDays, setExtendDays] = useState("");

  const getCurrentFilters = () => {
    return activeTab === "agent-request"
      ? agentRequestFilters
      : manualExtensionFilters;
  };

  const getApiFilters = () => {
    const currentFilters = getCurrentFilters();
    if (activeTab === "agent-request") {
      return {
        page: agentRequestPage + 1,
        limit: agentRequestPageLimit,
        gym_id: currentFilters.gym_id || "",
        date_from: currentFilters.date_from || "",
        date_to: currentFilters.date_to || "",
        approval_status: currentFilters.approval_status || "all",
      };
    } else {
      return {
        page: manualExtensionPage + 1,
        limit: manualExtensionPageLimit,
        gym_id: currentFilters.gym_id || "",
        date_from: currentFilters.date_from || "",
        date_to: currentFilters.date_to || "",
      };
    }
  };

  const onResetFilters = () => {
    if (activeTab === "agent-request") {
      setAgentRequestAllFilters(iniAgentRequestAllFilter);
      setAgentRequestPage(0);
    } else {
      setManualExtensionAllFilters(iniManualExtensionAllFilter);
      setManualExtensionPage(0);
    }
  };

  // Sync filters when allFilters change
  useEffect(() => {
    if (activeTab === "agent-request") {
      setAgentRequestFilters((prevs) => ({
        ...prevs,
        page: agentRequestPage + 1,
        limit: agentRequestPageLimit || 5,
        gym_id: agentRequestAllFilters.selectedGym?.value || "",
        date_from: agentRequestAllFilters.leadAddDateFrom || "",
        date_to: agentRequestAllFilters.leadAddDateTo || "",
        approval_status:
          agentRequestAllFilters.selectedApprovalStatus?.value || "all",
      }));
    } else {
      setManualExtensionFilters((prevs) => ({
        ...prevs,
        page: manualExtensionPage + 1,
        limit: manualExtensionPageLimit || 5,
        gym_id: manualExtensionAllFilters.selectedGym?.value || "",
        date_from: manualExtensionAllFilters.leadAddDateFrom || "",
        date_to: manualExtensionAllFilters.leadAddDateTo || "",
      }));
    }
  }, [
    agentRequestPage,
    agentRequestPageLimit,
    manualExtensionPage,
    manualExtensionPageLimit,
    agentRequestAllFilters,
    manualExtensionAllFilters,
    activeTab,
  ]);

  // Sync gym_id when userInfoData changes
  useEffect(() => {
    setAgentRequestAllFilters((prevs) => ({
      ...prevs,
      selectedGym:
        !isAdmin && !isMarketing
          ? {
              label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
              value:
                userInfoData?.gym_id ||
                userInfoData?.user_id ||
                userInfoData?.uid ||
                "",
            }
          : "",
    }));

    setManualExtensionAllFilters((prevs) => ({
      ...prevs,
      selectedGym:
        !isAdmin && !isMarketing
          ? {
              label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
              value:
                userInfoData?.gym_id ||
                userInfoData?.user_id ||
                userInfoData?.uid ||
                "",
            }
          : "",
    }));
  }, [
    userInfoData?.gym_id,
    isAdmin,
    isMarketing,
    isGym,
    userInfoData?.name,
    userInfoData?.gym_name,
    userInfoData?.user_id,
    userInfoData?.uid,
  ]);

  const handleAddNewClick = () => {
    setModValues({
      isModOpen: true,
      modName: "add-manual-extension",
      rowData: null,
    });
    setMemberMobile("");
    setMemberDetails(null);
    setExtendDays("");
  };

  const handleCloseAddModal = () => {
    setModValues(iniModValues);
    setMemberMobile("");
    setMemberDetails(null);
    setExtendDays("");
  };

  // days extension api call
  const handleSaveExtension = async () => {
    if (!memberDetails || !extendDays) {
      toast.error("Please enter the number of days to extend");
      return;
    }

    try {
      const payload = {
        extend_days: parseInt(extendDays),
        subscription_id:
          memberDetails.subscriptionId ||
          memberDetailsByMobile?.data?.[0]?.last_membership_details?.uid,
      };

      const result = await dispatch(
        commonPostPutApi({
          method: "PUT",
          endpoint: "/subscription/extend-days",
          payload,
          token: userInfoData.token,
        })
      );

      if (result?.payload?.status) {
        handleCloseAddModal();
        getSubscriptionExtensionData();
        toast.success(
          result?.payload?.message || "Subscription extended successfully!"
        );
      } else {
        const errorMessage =
          result?.error?.message ||
          result?.payload?.message ||
          "Failed to extend subscription";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error extending subscription:", error);
      toast.error("Something went wrong while extending subscription");
    }
  };

  const handleGetDetails = () => {
    if (!memberMobile.trim()) {
      toast.error("Please enter a mobile number");
      return;
    }
    setMemberDetails(null);
    
    dispatch(
      fetchMemberDetailsByMobileData({
        mobile: memberMobile,
        token: userInfoData.token,
      })
    );
  };

  const getSubscriptionExtensionData = useCallback(() => {
    if (userInfoData?.token) {
      const filters = getApiFilters();
      if (activeTab === "agent-request") {
        dispatch(
          fetchSubscriptionExtensionRequestsData({
            filters,
            token: userInfoData.token,
          })
        );
      } else {
        dispatch(
          fetchManualExtensionDataData({ filters, token: userInfoData.token })
        );
      }
    }
  }, [dispatch, userInfoData?.token, getApiFilters, activeTab]);

  useEffect(() => {
    if (userInfoData?.token) {
      getSubscriptionExtensionData();
    }
  }, [
    userInfoData?.token,
    agentRequestPage,
    agentRequestPageLimit,
    manualExtensionPage,
    manualExtensionPageLimit,
    activeTab,
    agentRequestFilters,
    manualExtensionFilters,
  ]);

  // Watch for member details API response
  useEffect(() => {
    if (
      memberDetailsByMobile &&
      memberDetailsByMobile.status &&
      memberDetailsByMobile.data &&
      memberDetailsByMobile.data.length > 0
    ) {
      const user = memberDetailsByMobile.data[0];
      const membership = user.last_membership_details;

      setMemberDetails({
        name: user.name || "N/A",
        mobile: user.mobile || "N/A",
        gymName: user.gym_name || "N/A",
        planName: membership?.plan_name || "N/A",
        startDate: membership?.start_date,
        expireDate: membership?.expire_date,
        subscriptionAdded: user.date_added,
        price: membership?.price || "N/A",
        duration: membership?.duration || "N/A",
      });
    } else if (memberDetailsByMobile && !memberDetailsByMobile.status) {
      setMemberDetails(null);
      // Show toast for "No users found" or similar error messages
      if (memberDetailsByMobile?.message) {
        toast.error(memberDetailsByMobile.message);
      } else {
        toast.error("No users found with this mobile number");
      }
    }
  }, [memberDetailsByMobile]);

  return (
    <>
      <Row>
        <Col>
          <Modal
            isOpen={modValues.isModOpen}
            onRequestClose={handleCloseAddModal}
            contentLabel="Add New Manual Extension Modal"
            ariaHideApp={false}
          >
            <div className="createNewCTOModalContainer">
              <ModalHeadAndClose
                title="Add New Manual Extension"
                onClose={handleCloseAddModal}
              />

              <ManualExtensionModal
                memberMobile={memberMobile}
                setMemberMobile={setMemberMobile}
                memberDetails={memberDetails}
                extendDays={extendDays}
                setExtendDays={setExtendDays}
                onGetDetails={handleGetDetails}
                onClose={handleCloseAddModal}
                onSave={handleSaveExtension}
                isLoading={memberDetailsByMobileLoading}
                isSaveDisabled={!extendDays}
              />
            </div>
          </Modal>
        </Col>
      </Row>
      <Row>
        <Col>
          <SubscriptionMainTabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />

          {activeTab === "agent-request" && (
            <>
              <CmnFilters
                from="subscription-extension"
                filters={agentRequestAllFilters}
                setFilters={setAgentRequestAllFilters}
                onClickReset={onResetFilters}
                userInfoData={userInfoData}
                isLoading={subscriptionExtensionRequestsLoading}
                activeTab={activeTab}
              />
              <SubscriptionExtensionTable
                isPage={agentRequestPage}
                setIsPage={setAgentRequestPage}
                pageLimit={agentRequestPageLimit}
                setPageLimit={setAgentRequestPageLimit}
                setModValues={setModValues}
                userInfoData={userInfoData}
                callFunction={getSubscriptionExtensionData}
              />
            </>
          )}

          {activeTab === "manual-extension" && (
            <>
              <CmnFilters
                from="subscription-extension"
                filters={manualExtensionAllFilters}
                setFilters={setManualExtensionAllFilters}
                onClickReset={onResetFilters}
                userInfoData={userInfoData}
                isLoading={manualExtensionDataLoading}
                activeTab={activeTab}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "20px",
                  marginTop: "20px",
                }}
              >
                <button
                  className="btn btn-primary"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    border: "none",
                    cursor: "pointer",
                    backgroundColor: "black",
                  }}
                  onClick={handleAddNewClick}
                >
                  <Plus color="white" />
                  Add New
                </button>
              </div>
              <ManualExtensionTable
                isPage={manualExtensionPage}
                setIsPage={setManualExtensionPage}
                pageLimit={manualExtensionPageLimit}
                setPageLimit={setManualExtensionPageLimit}
                setModValues={modValues}
                userInfoData={userInfoData}
                callFunction={getSubscriptionExtensionData}
              />
            </>
          )}
        </Col>
      </Row>
    </>
  );
};

export default SubscriptionExtenstionStructure;
